import {FormGroup} from '@angular/forms';
import {OnDestroy, OnInit} from '@angular/core';
import {untilDestroyed} from 'ngx-take-until-destroy';
import {PagingApiService} from '@abstract/paging-api.service';

/**
 * Абстрактный класс для компонента фильтров.
 */
export abstract class FiltersComponent implements OnInit, OnDestroy {
    protected constructor(
        private pagingService: PagingApiService,
    ) {}

    abstract form: FormGroup;

    ngOnInit(): void {
        this.pagingService.filters$.pipe(
            untilDestroyed(this),
        ).subscribe((values) => {
            this.updateForm(values);
        });
    }

    ngOnDestroy(): void {

    }

    onSubmit() {
        this.pagingService.setFilters(this.form.value);
    }

    onReset() {
        this.pagingService.resetFilters();
    }

    protected updateForm(values: object) {
        this.form.reset();
        this.form.patchValue(values);
    }
}
